import { ButtonHTMLAttributes, FunctionComponent } from 'react';
import classnames from 'classnames';

// components'
import Image from '@Components/Utils/Image';

// styles
import styles from './ButtonLoading.module.scss';

interface ButtonLoadingProps {
    loading?: boolean;
    className?: string;
}

const ButtonLoading: FunctionComponent<ButtonHTMLAttributes<HTMLButtonElement> & ButtonLoadingProps> = ({ loading, className, children, ...props }) => {
    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.btn_loading]: loading,
        },
        className,
    ]);

    return (
        <button {...props} className={wrapperClassName}>
            {loading ? <Image width={25} height={25} src={'/assets/loading.png'} /> : children}
        </button>
    );
};

ButtonLoading.defaultProps = {
    className: '',
    loading: false,
};

export default ButtonLoading;
